import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";

import { GiPaperTray } from "react-icons/gi";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetTemplatesCategoriesNames,
	fetchAddTemplateCategory,
	fetchUpdateTemplateCategory,
	fetchDeleteTemplateCategory,
	fetchCloneTemplateCategory
} from "actions/template";

import Step1 from "./Step1";
import Step2 from "./Step2";

import {
	RESET_TEMPLATE_CATEGORY,
	SET_TEMPLATE_CATEGORY,
	SET_TEMPLATE_CATEGORY_NAME_FR,
	SET_TEMPLATE_CATEGORY_NAME_EN,
	SET_TEMPLATE_CATEGORY_SYSTEM,
	ROLE_WEBMASTER
} from "actions/types.js";

class TemplateCategoryWizard extends Component {
	fetchAddTemplateCategory = () => {
		const {
			fetchAddTemplateCategory,
			name,
			lang,
			order,
			type,
			system,
			community
		} = this.props;

		fetchAddTemplateCategory({
			name,
			lang,
			order,
			system,
			type,
			communityId: community._id
		});
	};

	fetchUpdateTemplateCategory = () => {
		const { fetchUpdateTemplateCategory, _id, name, lang } = this.props;

		fetchUpdateTemplateCategory(_id, name, lang);
	};

	render() {
		const { update, isFetching, onClose, label } = this.props;
		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Français",
							stepComponent: Step1,
							stepId: "french"
						},
						{
							stepName: "Anglais",
							stepComponent: Step2,
							stepId: "english"
						}
					]}
					title={update ? `Mise à jour d'une ${label}` : `Ajout d'une ${label}`}
					finishButtonClick={
						update
							? this.fetchUpdateTemplateCategory
							: this.fetchAddTemplateCategory
					}
				/>
			</Grid>
		);
	}
}

class TemplatesCategories extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		wizard: null,
		categoryToDelete: null
	};

	componentDidMount() {
		const { fetchGetTemplatesCategoriesNames, type, community } = this.props;
		fetchGetTemplatesCategoriesNames(type, community._id);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetTemplatesCategoriesNames,
			type,
			snackErrorMsg,
			snackInfoMsg,
			newWizard,
			community
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetTemplatesCategoriesNames(type, community._id);
			this.autoCloseMessage();
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		const { fetchGetTemplatesCategoriesNames, type, community } = this.props;

		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_TEMPLATE_CATEGORY
		});
		fetchGetTemplatesCategoriesNames(type, community._id);
	};

	addWizard = (update = true, system = false) => {
		this.props.dispatch({
			type: SET_TEMPLATE_CATEGORY_SYSTEM,
			payload: system
		});
		this.setState({
			wizard: (
				<ConnectedTemplateCategoryWizard
					update={update}
					type={this.props.type}
					label={this.props.label}
					onClose={this.onClose}
				/>
			)
		});
	};

	editCategory = (id, name, lang) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_TEMPLATE_CATEGORY,
			payload: id
		});
		dispatch({
			type: SET_TEMPLATE_CATEGORY_NAME_FR,
			payload: name
		});
		if (lang && lang.en) {
			dispatch({
				type: SET_TEMPLATE_CATEGORY_NAME_EN,
				payload: lang.en.name
			});
		}
	};

	deleteCategory = id => {
		this.props.fetchDeleteTemplateCategory(id);
	};

	cloneCategory = id => {
		const { fetchCloneTemplateCategory, community } = this.props;
		fetchCloneTemplateCategory(id, community._id);
	};

	// Actions available on a category, depending on its system flag and the user role
	getActions = (system, used) => {
		const { user } = this.props;

		const actions = [];
		if (system) {
			if (!used) {
				actions.push({
					color: "success",
					icon: "content_copy",
					tooltip: "Dupliquer",
					onClick: this.cloneCategory
				});
			}
			if (user.role === ROLE_WEBMASTER) {
				actions.push({
					color: "info",
					icon: "edit",
					tooltip: "Modifier",
					onClick: this.editCategory
				});
				actions.push({
					color: "error",
					icon: "delete",
					tooltip: "Supprimer",
					onClick: this.delete
				});
			}
		} else {
			actions.push({
				color: "info",
				icon: "edit",
				tooltip: "Modifier",
				onClick: this.editCategory
			});
			actions.push({
				color: "error",
				icon: "delete",
				tooltip: "Supprimer",
				onClick: this.delete
			});
		}
		return actions;
	};

	getRoundButtons = (id, name, lang, system, used) =>
		this.getActions(system, used).map(action => (
			<Tooltip key={action.tooltip} title={action.tooltip} placement="bottom">
				<span>
					<MDButton
						variant="gradient"
						color={action.color}
						size="small"
						iconOnly
						circular
						disabled={!!this.state?.wizard}
						onClick={() => action.onClick(id, name, lang)}
						sx={{ mx: 0.25 }}
					>
						<Icon>{action.icon}</Icon>
					</MDButton>
				</span>
			</Tooltip>
		));

	getTemplatesCategories = () => {
		const { categories } = this.props;

		const categoriesObj = categories.map(
			({ _id, name, lang, system, used }) => {
				return {
					name,
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.getRoundButtons(_id, name, lang, system, used)}
						</MDBox>
					)
				};
			}
		);
		return categoriesObj;
	};

	delete = id => {
		this.setState({ categoryToDelete: id });
	};

	render() {
		const { color, message, wizard, categoryToDelete } = this.state;
		const { isFetchingList, label, title, user } = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<GiPaperTray size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								{title}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								data={this.getTemplatesCategories()}
								filterable
								columns={[
									{
										Header: "Nom",
										accessor: "name",
										sortable: true,
										filterable: false
									},
									{
										Header: "Actions",
										accessor: "actions",
										sortable: false,
										filterable: false
									}
								]}
								loading={isFetchingList}
								defaultPageSize={5}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText={"Aucunes " + label}
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox
							p={2}
							display="flex"
							flexWrap="wrap"
							justifyContent="flex-end"
							gap={1}
						>
							{user.role === ROLE_WEBMASTER && (
								<MDButton
									variant="gradient"
									color="info"
									onClick={() => this.addWizard(false, true)}
									disabled={!!wizard}
								>
									<Icon>add</Icon>
									&nbsp;{`Ajout d'une ${label} système`}
								</MDButton>
							)}
							<MDButton
								variant="gradient"
								color="primary"
								onClick={() => this.addWizard(false)}
								disabled={!!wizard}
							>
								<Icon>add</Icon>
								&nbsp;{`Ajout d'une ${label}`}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				{wizard}
				<ConfirmDialog
					open={!!categoryToDelete}
					message="Êtes-vous sûr de vouloir supprimer la catégorie ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ categoryToDelete: null })}
					onConfirm={() => {
						this.deleteCategory(categoryToDelete);
						this.setState({ categoryToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

class TemplatesCategoriesPage extends TemplatesCategories {
	static defaultProps = {
		type: "Template",
		title: "Catégories de modèles",
		label: "catégorie de modèles"
	};
}

class ActivitiesCategoriesPage extends TemplatesCategories {
	static defaultProps = {
		type: "Activity",
		title: "Catégories d'instants partage",
		label: "catégorie d'instants partage"
	};
}

class ProposalsCategoriesPage extends TemplatesCategories {
	static defaultProps = {
		type: "Proposal",
		title: "Catégories de besoins",
		label: "catégorie de besoins"
	};
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		_id,
		categoriesNames,
		name,
		lang,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		system
	} = state.templateCategoryReducer;
	const { user } = state.profileReducer;
	const { community } = state.entitiesReducer;

	return {
		isFetchingList,
		isFetching,
		_id,
		categories: categoriesNames,
		name,
		lang,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		system,
		user,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetTemplatesCategoriesNames,
			fetchAddTemplateCategory,
			fetchUpdateTemplateCategory,
			fetchDeleteTemplateCategory,
			fetchCloneTemplateCategory
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedTemplateCategoryWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(TemplateCategoryWizard);

const connectPage = Page => connect(mapStateToProps, mapDispatchToProps)(Page);

export default {
	TemplatesCategoriesPage: connectPage(TemplatesCategoriesPage),
	ActivitiesCategoriesPage: connectPage(ActivitiesCategoriesPage),
	ProposalsCategoriesPage: connectPage(ProposalsCategoriesPage),
	TemplateCategoryWizard: ConnectedTemplateCategoryWizard
};
